import { Component, Output, EventEmitter, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() totalItemsCart: number = 0;
  @Output() toggleSidenavEvent = new EventEmitter<void>();
  isScrolled = false;

  constructor(private router: Router) {
      
    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop || 0;
      this.isScrolled = scrollPosition > 0;
      console.log('Scroll detected:', {
        scrollPosition,
        isScrolled: this.isScrolled
      });
    });
  }

  ngOnInit() {
    console.log('Component initialized');
  
    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop || 0;
      const wasScrolled = this.isScrolled;
      this.isScrolled = scrollPosition > 0;
      
      if (wasScrolled !== this.isScrolled) {
        console.log('Scroll state changed:', {
          scrollPosition,
          isScrolled: this.isScrolled
        });
      }
    });
  }

  ngOnDestroy() {
    const scrollHandler = () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop || 0;
      this.isScrolled = scrollPosition > 0;
    };
    
    window.removeEventListener('scroll', scrollHandler);
  }

  onToggleSidenav() {
    this.toggleSidenavEvent.emit();
  }

  irinicio() {
    this.router.navigate(["/"]);
  }
}
